import { useMemo } from "react";
import { ApiFactory } from "../../core/config/ApiFactory";
import { useFetch } from "../../core/hooks/useFetch";
import { IRelatorioAvaliacoes } from "../interface/IRelatorioAvaliacoes";

export const useRelatorioAvaliacoes = (dataInicio?: string, dataFim?: string) => {
    const api = useMemo(() => ApiFactory.getApi("MS_PEDIDOS"), []);

    const parametros = new URLSearchParams();
    if (dataInicio) parametros.set("dataInicio", dataInicio);
    if (dataFim) parametros.set("dataFim", dataFim);

    const { data: relatorio, isLoading, error, handleRefresh } = useFetch<IRelatorioAvaliacoes>(
        api,
        `/relatorios/avaliacoes?${parametros.toString()}`
    );

    return { relatorio, isLoading, error, handleRefresh };
};
